import React from 'react';
import axios from 'axios';
import { api } from '@common/urls';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';

export default function ErrorPage() {
  return (
    <NotFoundPage />
  );
}

export async function getServerSideProps({ params }) {
  const { id } = params;
  try {
    const { data } = await axios.get(api.events.getOne(id), { params: { _id: id } });
    if (data.event) {
      const { sysName, _id } = data.event;
      return {
        redirect: {
          destination: `/events/${_id}/${sysName}`,
          permanent: false,
        }
      };
    }
    throw Error;
  } catch (error) {
    return { props: {} };
  }
}
